import {memo} from 'react';

import type {SVGProps} from 'react';

export const CheckFileIllustration = memo(function CheckFileIllustration(
  props: SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={64}
      height={64}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M43.7335 12H21.6001C19.3335 12 17.4668 13.8667 17.4668 16.1333V58.6667C17.4668 60.9333 19.3335 62.8 21.6001 62.8H53.2001C55.4668 62.8 57.3335 60.9333 57.3335 58.6667V25.4667C57.3335 24.8 57.0668 24.1333 56.5335 23.6L45.7335 12.8C45.2001 12.2667 44.5335 12 43.7335 12Z"
        fill="#A5D6A7"
      />
      <path
        d="M51.3325 26.3997V19.333H41.9992C40.5325 19.333 39.3325 18.133 39.3325 16.6663V7.33301"
        stroke="#18193F"
        strokeWidth={4}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6675 29.4668V52.6668C12.6675 54.9335 14.4008 56.6668 16.6675 56.6668H29.8675"
        stroke="#18193F"
        strokeWidth={4}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.3341 7.33301H16.6675C14.4008 7.33301 12.6675 9.06634 12.6675 11.333V18.133"
        stroke="#18193F"
        strokeWidth={4}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M51.3325 19.333L39.3325 7.33301"
        stroke="#18193F"
        strokeWidth={4}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M54.5325 57.3336C52.6659 58.5336 50.3992 59.2002 47.9992 59.2002C41.0659 59.2002 35.3325 53.6002 35.3325 46.5336C35.3325 44.5336 35.7325 42.8002 36.5325 41.0669"
        stroke="#18193F"
        strokeWidth={4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M42.8003 35.0667C44.4003 34.2667 46.1336 33.8667 48.0003 33.8667C54.9336 33.8667 60.667 39.4667 60.667 46.5334C60.667 47.6 60.5336 48.5334 60.267 49.4667"
        stroke="#18193F"
        strokeWidth={4}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.1333 46.5336L47.2 49.6002L53.6 43.0669"
        stroke="#18193F"
        strokeWidth={4}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});
